module.exports = __webpack_public_path__ + "img/20167d9f3615e2687587f89d1cba2b45.svg";